import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import AccessDenied from "./AccessDenied";

export default function ProtectedRoute({ children, roles, permission }) {
  const { user, can, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center bg-background">
        <div className="flex flex-col items-center gap-3 text-muted-foreground">
          <Loader2 className="w-7 h-7 animate-spin text-primary" />
          <span className="font-display text-xs uppercase tracking-widest">Securing your session…</span>
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  const role = String(user.role || "").toLowerCase().replace("office_user", "office");
  const allowedRoles = (roles || []).map((r) => String(r).toLowerCase().replace("office_user", "office"));
  // Match the backend hierarchy: SUPER_ADMIN is a superset of ADMIN. Keeping
  // this rule here prevents a valid super-admin session from being blocked by
  // older routes that still list only the admin role.
  const roleAllowed = allowedRoles.includes(role)
    || (role === "super_admin" && allowedRoles.includes("admin"));
  if (allowedRoles.length && !roleAllowed) {
    return <AccessDenied message="This section is restricted to authorized roles only." />;
  }
  if (permission && !can(permission)) {
    return <AccessDenied message="You do not have the required permission token to view this page." />;
  }
  return children;
}
